<script>
  import Icon, {
    InformationCircle,
    CheckCircle,
    XCircle,
    X,
  } from "svelte-hero-icons";
  import classNames from "../utils/classNames";

  export let onClose = () => {};
  export let notify;

  let _color = "";
  let icon = InformationCircle;

  const { title = "", subtitle: subTitle, color = "info" } = notify;

  $: switch (color) {
    case "success":
      _color = "text-green-400 outline-none";
      icon = CheckCircle;
      break;

    case "error":
      _color = "text-red-400 outline-none";
      icon = XCircle;
      break;

    case "info":
      _color = "text-blue-400 outline-none";
      icon = InformationCircle;
      break;
    case "warning":
      _color = "text-yellow-400 outline-none";
      icon = InformationCircle;
      break;

    default:
      _color = color;
      break;
  }
</script>

<!-- This example requires Tailwind CSS v2.0+ -->
<!-- Global notification live region, render this permanently at the end of the document -->
<!--
        Notification panel, dynamically insert this into the live region when it needs to be displayed
  
        Entering: "transform ease-out duration-300 transition"
          From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          To: "translate-y-0 opacity-100 sm:translate-x-0"
        Leaving: "transition ease-in duration-100"
          From: "opacity-100"
          To: "opacity-0"
      -->
<div
  class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
>
  <div class="p-4">
    <div class="flex items-start">
      <div class="shrink-0">
        <Icon src={icon} class={classNames("h-6 w-6", _color)} />
      </div>

      <div class="ml-3 w-0 flex-1 pt-0.5">
        <p class="text-sm font-medium text-gray-900">
          {title}
        </p>
        <p class="mt-1 text-sm text-gray-500">
          {#if Array.isArray(subTitle)}
            <ul class={subTitle.length > 1 ? "bullets" : null}>
              {#each subTitle as msg}
                <li>{msg}</li>
              {/each}
            </ul>
          {:else}
            {subTitle}
          {/if}
        </p>
      </div>
      <div class="ml-4 shrink-0 flex">
        <button
          class="bg-white border-0 rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          on:click={onClose}
        >
          <span class="sr-only">Close</span>
          <Icon src={X} class="h-5 w-5 outline-none" solid />
        </button>
      </div>
    </div>
  </div>
</div>

<style>
  .bullets {
    list-style: initial !important;
  }
</style>
